import React from 'react';
import { useForm } from '../../context/FormContext';

export const PassportStep = ({ onAutoAdvance }) => {
  const { formData, updateFormData } = useForm();

  const handleSelect = (value) => {
    updateFormData({ has_uk_passport: value });
    setTimeout(() => onAutoAdvance?.(), 300);
  };

  return (
    <div className="space-y-6" data-testid="passport-step">
      <div className="text-center">
        <h2 className="text-xl md:text-2xl font-bold text-slate-900 mb-2" style={{ fontFamily: 'Manrope, sans-serif' }}>
          UK Passport
        </h2>
        <p className="text-slate-600 hidden md:block">Do you hold a valid UK passport?</p>
      </div>

      <div className="flex justify-center gap-4">
        <button
          onClick={() => handleSelect(true)}
          className={`w-32 p-6 rounded-xl border-2 transition-all text-center text-lg font-semibold ${
            formData.has_uk_passport === true
              ? 'brand-border brand-bg-light brand-text'
              : 'border-slate-200 hover:border-slate-300 text-slate-700'
          }`}
          data-testid="passport-yes"
        >
          Yes
        </button>
        <button
          onClick={() => handleSelect(false)}
          className={`w-32 p-6 rounded-xl border-2 transition-all text-center text-lg font-semibold ${
            formData.has_uk_passport === false
              ? 'brand-border brand-bg-light brand-text'
              : 'border-slate-200 hover:border-slate-300 text-slate-700'
          }`}
          data-testid="passport-no"
        >
          No
        </button>
      </div>
    </div>
  );
};

export default PassportStep;
